var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header-page',{attrs:{"image":_vm.page.imageId}},[_c('h1',[_vm._v(_vm._s(_vm.$t('views.contacts.title')))])]),_c('div',{staticClass:"body-page"},[_c('div',{staticClass:"app-container"},_vm._l((_vm.contactsList),function(contact){return _c('category-contacts',_vm._b({key:contact.id},'category-contacts',contact,false))}),1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }